import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTimelineItem,{style:(_vm.hideDot ? 'margin-top: -16px;' : ''),attrs:{"small":"","hide-dot":_vm.hideDot,"color":"main lighten-1"}},[(!_vm.hideDot)?_c(VRow,[_c('h2',{staticClass:"text-subtitle-2 text-uppercase mt-3 ml-3",domProps:{"textContent":_vm._s(_vm.matchTime)}})]):_vm._e(),_c(VRow,{staticClass:"ma-0 mt-3"},[_c('list-item-match',{attrs:{"match":_vm.match,"team":_vm.team,"editMode":_vm.editMode}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }